import { PauseIcon, PlayIcon } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";
import { useTranslate } from "@refinedev/core";
import styled from "styled-components";
import { popIn } from "./Autopilot.styled";
import { useTypingText } from "@/hooks/useTypingText";
import { radius } from "@libertify/ui";

export const VoiceCardItem: React.FC<{
  chapter: number;
  text: string;
  // isPlaying: boolean;
  // onToggle: () => void;
  onTypingDone: () => void;
  skipTyping?: boolean;
}> = ({
  chapter,
  text,
  //  isPlaying,
  //  onToggle,
  onTypingDone,
  skipTyping,
}) => {
  const t = useTranslate();
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);
  const onTypingDoneRef = useRef(onTypingDone);
  useEffect(() => {
    onTypingDoneRef.current = onTypingDone;
  });

  const typedText = useTypingText(text, !skipTyping, () =>
    onTypingDoneRef.current()
  );
  const displayed = skipTyping ? text : typedText;

  useEffect(() => {
    if (skipTyping) {
      onTypingDoneRef.current();
    }
  }, [skipTyping]);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [displayed]);

  return (
    <VoiceCard>
      <ChapterLabel>
        {t("media.autopilot.scenePrefix")} {chapter}
      </ChapterLabel>
      <VoiceText ref={textRef} $expanded={expanded}>
        {displayed}
      </VoiceText>
      {(isClamped || expanded) && (
        <ViewMoreBtn onClick={() => setExpanded((v) => !v)}>
          {expanded
            ? t("media.autopilot.viewLess")
            : t("media.autopilot.viewMore")}
        </ViewMoreBtn>
      )}
      {/* <PlayPauseBtn $playing={isPlaying} onClick={onToggle}>
        {isPlaying ? (
          <PauseIcon size={13} color="white" weight="fill" />
        ) : (
          <PlayIcon size={13} color="white" weight="fill" />
        )}
      </PlayPauseBtn> */}
    </VoiceCard>
  );
};

const VoiceCard = styled.div`
  flex-shrink: 0;
  width: 160px;
  border-radius: ${radius.box}px;
  background: white;
  border: 1px solid #e5e7eb;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: ${popIn} 0.35s ease both;
`;

const ChapterLabel = styled.span`
  font-size: 10px;
  color: #9ca3af;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const VoiceText = styled.p<{ $expanded: boolean }>`
  margin: 0;
  font-size: 11px;
  color: #374151;
  line-height: 1.6;
  overflow: hidden;
  ${(p) =>
    !p.$expanded &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  `}
`;

const ViewMoreBtn = styled.span`
  font-size: 11px;
  color: #14b8a6;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const PlayPauseBtn = styled.div<{ $playing: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: ${radius.circle};
  background: ${(p) => (p.$playing ? "#0d9488" : "#14b8a6")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: center;
  flex-shrink: 0;
  transition:
    background 0.15s,
    transform 0.15s;

  &:hover {
    transform: scale(1.05);
  }
`;
